import React from 'react';
import './Project.css';

const ProjectCard = ({project}) => {
    return (
        <div className = 'col-md-6 col-lg-4 mb-4 text-center text-white'>
            <div className = 'project m-2 p-3'>
            <div className="card-group m-3 ">
                <div class="card m-0">
                    <img className="card-img-top"  src= {project.picture} alt=""/>
                    <div class="card-body">
                        <h4 className="card-title"> {project.title} </h4>
                        <p class="card-text"> {project.material} </p>
                        <button className="btn btn-dark"><a className = 'text-white' href= {project.url} > Visit Site </a></button>
                        <button className="btn btn-warning m-2"><a className = 'text-white' href= {project.gitHub} > GitHub Repository </a></button>
                    </div>
                </div>
            </div>
            </div>
        </div>
    );
};

export default ProjectCard;